module.exports = __webpack_public_path__ + "assets_app/img/key_7.22ee92f8.svg";